<template>
  <div class="cp-set-hours main">
    <div class="divider" />

    <div class="row">
      <p><i class="far fa-clock icon" />Hours of Operation</p>
      <div v-if="!editHours" @click="editHours = true">
        <p class="value" style="margin-top: 4px; margin-bottom: 6px">
          <span v-if="alwaysOpen">Always Open</span>
          <span v-else>Selected Hours</span>
        </p>
        <div v-if="!alwaysOpen" style="margin-left: 32px">
          <!-- <p v-for="(hours, day) in business.data.hours" :key="day"> -->
          <p v-for="day in days" :key="day" style="padding: 4px 0">
            <span class="day">{{ $t(`dow.${day}`) }}</span>
            <!-- <span class="hours">{{ hours || "Closed" }}</span> -->
            <span class="hours">{{ dayHours(day) }}</span>
          </p>
        </div>
      </div>
      <div v-if="!editHours" class="save-wrapper" style="margin-bottom: 10px">
        <!-- <p v-if="editHours" class="button is-light" @click="editHours = false">
          <span>Cancel</span>
        </p> -->
        <p class="button has-text-success" @click="editHours = true">
          <span>Change</span>
        </p>
      </div>
      <div v-if="editHours" style="margin: 10px 0">
        <p style="margin-left: 20px; margin-bottom: 10px; font-weight: 500">
          <span
            class="button is-rounded"
            :class="{ 'is-white': alwaysOpen }"
            @click="setHoursType('selected-hours')"
            >Selected Hours</span
          >&nbsp;
          <span
            class="button is-rounded"
            :class="{ 'is-white': !alwaysOpen }"
            @click="setHoursType('always-open')"
            >Always Open</span
          >
        </p>
        <div v-if="!alwaysOpen" style="margin-left: 20px">
          <div
            class="field has-addons"
            v-for="d in days"
            :key="d + '2'"
            style="margin-bottom: 2px"
          >
            <p
              class="control"
              style="margin-bottom: 0"
              @click="propagateHours(d)"
            >
              <a
                class="button is-static is-rounded"
                :class="{ 'has-text-danger': !hours[d] }"
                style="width: 60px"
                >{{ capitaliseFirstLetter(d) }}</a
              >
            </p>
            <p class="control is-expanded">
              <input
                class="input"
                :class="{ 'is-danger': errors.includes(d) }"
                type="text"
                v-model="hours[d]"
                placeholder="1100-1400, 1600-2000"
              />
            </p>
            <p v-if="hours[d]" class="control">
              <span
                class="button has-text-grey"
                style="padding: 8px"
                @click="hours[d] = null"
                ><i class="fa fa-times-circle"
              /></span>
            </p>
          </div>
          <p class="hint">For example: 0900-1800 or 1100-1400, 1600-2000</p>
          <p class="hint">Leave blank if closed that day</p>
        </div>
        <div class="save-wrapper" style="margin-top: 16px">
          <span class="button is-light" @click="editHours = false">
            Cancel </span
          >&nbsp;
          <span v-if="updatingHours" class="button"
            ><i class="fa fa-spinner fa-spin"
          /></span>
          <span v-else class="button has-text-success" @click="saveHours">
            Save
          </span>
        </div>
      </div>
    </div>

    <div class="divider" />

    <div class="row" :style="pausedStyle">
      <p><i class="far fa-hourglass icon" />Pause Orders</p>
      <p class="value" @click="showPauseOptions = true">
        <span v-if="commerce.data.paused"
          >Not Accepting Orders -
          <span class="has-text-danger">PAUSED</span></span
        >
        <span v-else
          >Accepting Orders -
          <span class="has-text-success">Not Paused</span></span
        >
      </p>
      <div v-if="showPauseOptions" class="value" style="margin: 8px 22px">
        <span v-if="commerce.data.paused" :class="btn" @click="setPause(false)">
          <i class="fa fa-play has-text-success" />&nbsp;Un-Pause - Allow new
          orders
        </span>
        <span v-else :class="btn" @click="setPause(true)">
          <i class="fa fa-hourglass has-text-danger" />&nbsp;Pause - Stop new
          orders
        </span>
        &nbsp;
        <span v-if="updatingPause" :class="btn">
          <i class="fa fa-spinner fa-spin" />
        </span>
      </div>
      <div class="save-wrapper">
        <p
          v-if="showPauseOptions"
          class="button is-light"
          @click="showPauseOptions = false"
        >
          Cancel
        </p>
        <p
          v-else
          class="button has-text-success"
          @click="showPauseOptions = true"
        >
          Change
        </p>
      </div>
    </div>

    <!--  -->

    <div class="divider" />

    <div class="row">
      <p><i class="far fa-calendar-alt icon" />Go on Holiday</p>
      <p class="value" @click="showHolidayOptions = true">
        <span v-if="onHolidayUntil"
          >On Holiday until
          <span class="has-text-danger">{{ onHolidayUntil }}</span></span
        >
        <span v-else
          >Not on Holiday -
          <span class="has-text-success">Normal Hours</span></span
        >
      </p>

      <div v-if="showHolidayOptions" class="value" style="margin: 8px 22px">
        <div v-if="updatingHoliday" :class="btn" style="margin-left: 10px">
          <i class="fa fa-spinner fa-spin" />
        </div>
        <div v-else class="holiday-buttons">
          <p class="buttons">
            <span v-if="isOnHoliday" :class="btn" @click="setHoliday()">
              <i class="fa fa-play has-text-success" />&nbsp;Re-open</span
            >
          </p>
          <p class="buttons single-line no-scrollbar">
            <span :class="btn" @click="setHoliday(1)">1 Day</span>
            <span :class="btn" @click="setHoliday(2)">2 Days</span>
            <span :class="btn" @click="setHoliday(3)">3 Days</span>
            <span :class="btn" @click="setHoliday(4)">4 Days</span>
          </p>
          <p class="buttons">
            <span :class="btn" @click="triggerDatePicker">
              <i class="far fa-calendar-alt" />&nbsp;Set Date</span
            >
            <!-- <span v-if="isOnHoliday" :class="btn" @click="setHoliday()">
              <i class="fa fa-play has-text-success" />&nbsp;Re-open</span
            > -->
          </p>
        </div>
      </div>

      <div v-if="showDatePicker">
        <!-- :locale="locale" -->
        <b-datepicker
          ref="datepicker"
          class="hide-datepicker"
          v-model="holidayEndDate"
          icon-pack="fa"
          :min-date="new Date()"
          @input="datePicked"
        >
        </b-datepicker>
      </div>

      <div class="save-wrapper">
        <p
          v-if="showHolidayOptions"
          class="button is-light"
          @click="showHolidayOptions = false"
        >
          Cancel
        </p>
        <p
          v-else
          class="button has-text-success"
          @click="showHolidayOptions = true"
        >
          Change
        </p>
      </div>
    </div>

    <div style="height: 60px" />
  </div>
</template>


<script>
export default {
  name: "CPSetHours",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      editHours: false,
      btn: "button is-rounded",
      days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
      hours: null, // set on mounted
      hoursType: null, // set on mounted
      updatingHours: false,
      showPauseOptions: false,
      updatingPause: false,
      showHolidayOptions: false,
      updatingHoliday: false,
      errors: [], // days with errors
      holidayEndDate: null,
      showDatePicker: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    alwaysOpen() {
      return this.hoursType === "always-open";
      // return this.business.data.hours_type === "always-open";
    },
    isOnHoliday() {
      if (!this.commerce.data.closed_until) return null;
      return this.isFutureTime(this.commerce.data.closed_until);
    },
    onHolidayUntil() {
      if (!this.isOnHoliday) return null;
      var dt = new Date(this.commerce.data.closed_until);
      return dt.toLocaleString("en-GB");
      // return this.shortDateTime(this.commerce.data.closed_until);
    },
    pausedStyle() {
      if (!this.commerce.data.paused) return;
      return "background-color: #ffd3d9";
    },
    locale() {
      return "ja-JP";
    },
  },
  mounted() {
    if (this.commerce.data.closed_until) {
      this.holidayEndDate = new Date(this.commerce.data.closed_until);
    }
    this.hoursType = this.business.data.hours_type || "always-open";
    if (this.business.data.hours) {
      this.hours = this.business.data.hours;
    } else {
      this.hours = {
        mon: null,
        tue: null,
        wed: null,
        thu: null,
        fri: null,
        sat: null,
        sun: null,
      };
    }
  },
  methods: {
    dayHours(day) {
      if (!this.business.data.hours) return "Closed";
      return this.business.data.hours[day] || "Closed";
    },
    triggerDatePicker() {
      this.showDatePicker = true;
      this.$nextTick(() => this.$refs.datepicker.toggle());
    },
    datePicked() {
      this.setHoliday(-1); // flag to indicate use this.holidayEndDate
    },
    setHoliday(days) {
      var closedUntil = null;
      if (days === -1) {
        closedUntil = this.holidayEndDate.toISOString();
      } else if (days) {
        var dt = new Date();
        dt.setDate(dt.getDate() + days);
        dt.setHours(0, 0, 0, 0);
        closedUntil = dt.toISOString();
      }
      this.updatingHoliday = true;
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.commerce.id,
          data: { closed_until: closedUntil },
        })
        .then((res) => {
          this.successToast("Updated holiday");
          if (closedUntil) {
            var msg = `Re-opening on<br>${closedUntil}`;
            this.infoToast(msg, "bottom", 10000);
          }
          this.commerce.data = res.data.data;
          this.showHolidayOptions = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingHoliday = false));
    },
    setPause(state) {
      this.updatingPause = true;
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.commerce.id,
          data: { paused: state },
        })
        .then((res) => {
          this.successToast("Updated pause");
          this.commerce.data = res.data.data;
          this.showPauseOptions = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingPause = false));
    },
    setHoursType(type) {
      this.hoursType = type; // save later
      // this.business.data.hours_type = type;
    },
    propagateHours(d) {
      var dow = this.capitaliseFirstLetter(d);
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='far fa-clock'></i>&nbsp;Propagate Hours
        </p>
        <p style='margin-bottom:10px'>Copy these hours to all days of the week?</p>
        <p style='font-weight:550; opacity:0.8'> 
          <i>${dow}: ${this.hours[d] || "Closed"}</i> 
        </p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Propagate",
      }).then((val) => {
        if (!val.value) return;
        for (const key in this.hours) {
          this.hours[key] = this.hours[d];
        }
      });
    },
    validHours() {
      var invalid = 0;
      this.errors = [];
      Object.entries(this.hours).forEach(([key, value]) => {
        console.log(`${key} ${value}`);
        if (!value) return; // closed if blank
        var clean = value
          .replace(/\s/g, "")
          .replace(/:/g, "")
          .replace(/\./g, "");
        var arr = clean.split(",");
        arr.forEach((str) => {
          var startEnd = str.split("-");
          if (startEnd.length !== 2) {
            invalid += 1;
            this.errors.push(key);
            return;
          }
          var start = startEnd[0];
          var end = startEnd[1];
          if (start.length !== 4 || end.length !== 4) {
            invalid += 1;
            this.errors.push(key);
            return;
          }
          if (isNaN(start) || isNaN(end)) {
            invalid += 1;
            this.errors.push(key);
            return;
          }
          if (parseInt(start) >= parseInt(end)) {
            invalid += 1;
            this.errors.push(key);
            return;
          }
        });
      });
      if (invalid) {
        var msg = `<div style='text-align:left'>
        <p style='margin-bottom:8px; font-weight: 550; font-size:1.2em'>Please enter hours like:</p>
        <p>Single: <i>0800-2000</i></p>
        <p>Multiple: <i>1100-1400, 1600-2000</i></p>
        <p>Closed: <i>leave blank</i></p>
        </div>`;
        this.errorToast(msg, "top", 10000);
        return false;
      }
      console.log("Valid Hours!");
      return true;
    },
    saveHours() {
      if (!this.validHours()) return;
      this.updatingHours = true;
      var obj = {
        hours_type: this.hoursType,
        hours: this.hours,
      };
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated hours");
          this.business.data = res.data.data;
          this.editHours = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingHours = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.day {
  background-color: rgb(247, 247, 247);
  font-size: 0.9em;
  font-weight: 500;
  color: #aaa;
  width: 36px;
  padding: 0 2px;
  margin-top: -2px;
  display: inline-block;
}
.hours {
  color: grey;
  border-bottom: 1px dotted #ddd;
  margin-left: 8px;
}
.hint {
  margin-left: 20px;
  margin-top: 8px;
  color: grey;
  font-size: 0.8em;
}
.is-white {
  background-color: rgb(250, 250, 250);
  color: grey;
  font-weight: initial;
}
.hide-datepicker {
  width: 0;
  position: absolute;
  left: -20px;
}
.single-line {
  display: block;
  white-space: nowrap;
  overflow: auto;
  /* max-width: 100vw; */
}
.holiday-buttons .buttons {
  margin-bottom: 8px;
}
</style>
